import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
const LOCAL_SHORT_URL = import.meta.env.VITE_LOCAL_SHORT_URL;

interface PrivateRouteProps {
  children: JSX.Element;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const domain = window.location.hostname;
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(!!Cookies.get("userToken"));
  const authChannel = new BroadcastChannel("auth");

  useEffect(() => {
    authChannel.onmessage = (event) => {

      if (event.data === "login") {
        Cookies.set("userToken", event.data.token);
        setIsLoggedIn(true);
      } else if (event.data === "logout") {
        Cookies.remove("userToken");
        setIsLoggedIn(false);
      }
    };
  }, []);

  if (isLoggedIn) {
    return children
  } else {
    return <Navigate
      to={domain === LOCAL_SHORT_URL ? "/" : "/login"}
      state={{ from: location }} // Store last visited route
      replace
    />
  }
};

export default PrivateRoute;
